export const showroomVisualPath = {
  INDEX: '/',
  BLOCK: '/:block',
  BLOCK_FLOOR: '/:block/:floor'
};
